import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import mapInfoUtils from '../utils/mapInfoUtils';

export default function AddSpot() {
	const [loading, setLoading] = React.useState(false);
	const [title, setTitle] = React.useState('');
	const [description, setDescription] = React.useState('');
	const [type, setType] = React.useState('');

	const [lat, setLat] = React.useState<number>();
	const [lng, setLng] = React.useState<number>();

	async function handleClick() {
		setLoading(false);
		const obj = {
			title,
			description,
			type,
			latlng: { lat, lng },
		};
		const resp = await mapInfoUtils.addPoint(obj);
		console.log(resp);
		setLoading(false);
		// const res = await mapInfoUtils.getAllPoints();
		// console.log(res);
	}
	return (
		<Box
			component="form"
			sx={{
				'& > :not(style)': { m: 1, width: '25ch' },
			}}
			noValidate
			autoComplete="off"
		>
			Add:
			<Box>
				<TextField
					id="title"
					label="title"
					variant="outlined"
					onChange={(e) => {
						setTitle(e.target.value);
					}}
				/>
			</Box>
			<Box>
				<TextField
					id="type"
					label="type"
					variant="outlined"
					onChange={(e) => {
						setType(e.target.value);
					}}
				/>
			</Box>
			<Box>
				<TextField
					id="description"
					label="description"
					variant="outlined"
					onChange={(e) => {
						setDescription(e.target.value);
					}}
				/>
			</Box>
			<Box>
				<TextField
					id="lat"
					label="lat"
					variant="outlined"
					onChange={(e) => {
						setLat(+e.target.value);
					}}
				/>
			</Box>
			<Box>
				<TextField
					id="lng"
					label="lng"
					variant="outlined"
					onChange={(e) => {
						setLng(+e.target.value);
					}}
				/>
			</Box>
			<LoadingButton
				color="secondary"
				// eslint-disable-next-line react/jsx-no-bind
				onClick={handleClick}
				loading={loading}
				loadingPosition="start"
				startIcon={<SaveIcon />}
				variant="contained"
			>
				Save
			</LoadingButton>
		</Box>
	);
}
